"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SketchAnnotations = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const lodash_1 = require("lodash");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const PenDraw_1 = __importDefault(require("../PenDraw"));
function SketchAnnotations({ curves, onFullscreen, }) {
    const [isFullScreen, setIsFullScreen] = (0, react_1.useState)(false);
    const [size, setSize] = (0, react_1.useState)({ width: 0, height: 0 });
    const onToggleFullScreen = () => {
        onFullscreen(!isFullScreen);
        setIsFullScreen(!isFullScreen);
    };
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (containerRef.current) {
            setSize({
                width: containerRef.current.offsetWidth - 64,
                height: containerRef.current.offsetHeight - 64,
            });
        }
    }, [isFullScreen]);
    return ((0, jsx_runtime_1.jsxs)(Container, { "$isFullScreen": isFullScreen, "data-e2e": 'SketchAnnotations_Container', children: [(0, jsx_runtime_1.jsx)(CurvesContainer, { ref: containerRef, "$isFullScreen": isFullScreen, "data-e2e": 'SketchAnnotations_CurvesContainer', children: (0, jsx_runtime_1.jsx)(PenDraw_1.default, { curves: curves, width: size.width, height: size.height, color: "#000000", size: 12, opacity: 1, drawable: false, drawOutside: true, onPaintEnd: lodash_1.noop, setCurves: lodash_1.noop, isGlobalPen: false, "data-e2e": 'SketchAnnotations_PenDrawPanel' }) }), (0, jsx_runtime_1.jsx)(ButtonsContainer, { "data-e2e": 'SketchAnnotations_ButtonsContainer', children: (0, jsx_runtime_1.jsx)(StyledHide, { onClick: onToggleFullScreen, isSelected: isFullScreen, "data-e2e": 'SketchAnnotations_StyledHide' }) })] }));
}
exports.SketchAnnotations = SketchAnnotations;
const StyledHide = (0, styled_components_1.default)(ui_1.HideButton) `
  background-color: ${({ theme }) => theme.backgroundSenary};
`;
const Container = styled_components_1.default.div `
  position: relative;
  width: 304px;
  height: 182px;
  border-radius: 4px;
  background-size: cover;

  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);

  ${({ $isFullScreen }) => $isFullScreen &&
    (0, styled_components_1.css) `
      display: flex;

      justify-content: center;
      align-content: center;
      flex-wrap: wrap;

      position: fixed !important;

      top: 0 !important;
      left: 0 !important;

      width: 100vw !important;
      height: 100vh !important;

      z-index: 9999 !important;

      margin: 0 !important;
      max-width: unset !important;
      max-height: unset !important;
      background-color: ${({ theme }) => theme.background} !important;
    `}
`;
const CurvesContainer = styled_components_1.default.div `
  padding: 16px;
  width: 304px;
  height: 182px;

  & canvas {
    padding: 16px !important;

    position: ${({ $isFullScreen }) => $isFullScreen ? 'relative' : 'absolute'};
  }

  ${({ $isFullScreen }) => $isFullScreen &&
    (0, styled_components_1.css) `
      background-color: ${({ theme }) => theme.backgroundSenary};
      width: 75vw !important;
      height: 56.25vw !important;
    `}
`;
const ButtonsContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  flex-direction: row;
  top: 10px;
  right: 10px;
  gap: 10px;
`;
